// extracted by mini-css-extract-plugin
export default {"recruitsContainer":"Recruits_recruitsContainer__qJRFa","mainContent":"Recruits_mainContent__nVD5D"};